import AccessManager from "./AccessManager";
import Announcements from "./Announcements";
import Content from "./Content";
import Geolocation from "./Geolocation";
import InstantMessaging from "./InstantMessaging";
import Poll from "./Poll";
import RSVP from "./RSVP";
import Waitlist from "./Waitlist";
import Unknown from "./Unknown";
import { types } from "../../graphql";

export default function getComponentForBlockType(blockType: string) {
  // const path = `./blocks/${blockType}`;
  // return lazy(() => import(path));
  switch (blockType) {
    case types.BlockType.Announcements:
      return Announcements;
    case types.BlockType.InstantMessaging:
      return InstantMessaging;
    case types.BlockType.AccessManager:
      return AccessManager;
    case types.BlockType.Geolocation:
      return Geolocation;
    case types.BlockType.Content:
      return Content;
    case types.BlockType.Poll:
      return Poll;
    case types.BlockType.RSVP:
      return RSVP;
    case types.BlockType.Waitlist:
      return Waitlist;
    default:
      return Unknown;
  }
}
